/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown>, unit: NonNullable<unknown> }} Lot_Items_Available_HintInputs */

const vi_lot_items_available_hint = /** @type {(inputs: Lot_Items_Available_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Còn ${i?.qty} ${i?.unit}`)
};

/**

* @param {Lot_Items_Available_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_available_hint = /** @type {((inputs: Lot_Items_Available_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_Available_HintInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_available_hint(inputs)
});